import { MeshBasicNodeMaterial, Vector2 } from 'three/webgpu'
import { uniform, uv, abs, max, min, length, smoothstep, float } from 'three/tsl'

export default class RoundedImageMaterial extends MeshBasicNodeMaterial {
	constructor(options = {}) {
		super({ transparent: true, toneMapped: false, ...options })

		this.size = uniform(new Vector2(1, 1))
		this.radius = uniform(0)

		const p = uv().sub(0.5).mul(this.size)
		const q = abs(p).sub(this.size.mul(0.5).sub(this.radius))
		const distance = length(max(q, 0))
			.add(min(max(q.x, q.y), 0))
			.sub(this.radius)

		this.opacityNode = smoothstep(float(0.75), float(-0.75), distance)
	}
}
